<div class="row driver-filter align-content-end">
	<div class="input-group justify-content-end">
		<span class="w-100 input-group-text bg-transparent border-1 border-left z-1 filter-container">
			<a class="nav-link dropdown-toggle py-1 flex-grow-1 text-start" href="#" role="button" data-bs-toggle="dropdown"
				aria-expanded="false" [attr.data-bs-auto-close]="closeOnOutsideClick ? 'outside' : 'false'" #dropdownTrigger>
				<i class="ph ph-funnel-simple"></i>
				<span class="text-dark px-2">{{ !isLoaded() ? ('shared.loading' | transloco) : labelTitle }}</span>
			</a>
			<span *ngIf="selectedEntitiesCount > 0" class="bg-danger text-white py-1 px-2 rounded-2 text-xs">
				{{ selectedEntitiesCount }}
			</span>

			<ul class="dropdown-menu custom-dropdown border-0" [ngClass]="{ 'bulk': isBulkAssignment }" #dropdown>
				<div class="d-flex justify-content-center" *ngIf="!isLoaded()">
					<span class="spinner-border"></span>
				</div>
				<div class="sticky-top bg-white p-2" *ngIf="isLoaded()">
					<div class="input-group align-items-center">
						<div
							class="col-1 ps-2 d-flex justify-content-center align-items-center rounded-start-3 border-1 search-icon">
							<i class="ph ph-magnifying-glass"></i>
						</div>

						<div class="col-11">
							<input type="text" class="ps-3 rounded-end-3 border-1 search-input" [attr.aria-label]="'accountFilter.search' | transloco"
								[placeholder]="(entityType == 'driver' ? 'shared.assetAssignmentFilter.searchDrivers' : 'shared.assetAssignmentFilter.searchVehicles') | transloco" [(ngModel)]="driverName"
								(input)="searchEntities($event)" (click)="openDropdown($event)" />
						</div>
					</div>
				</div>

				<div class="dropdown-scroll" *ngIf="isLoaded()">
					<cdk-virtual-scroll-viewport itemSize="33" minBufferPx="400" maxBufferPx="1000" class="viewport" [ngClass]="{ 'bulk-viewport': isBulkAssignment }">
						<li *cdkVirtualFor="let item of filteredTree" class="dropdown-item"
							[ngStyle]="{ '--level': item.hierarchyLevel }">
							<div class="list-container">
								<label [ngStyle]="{ 'padding-left.px': item.hierarchyLevel * 32 }"
									[ngClass]="{'parent-item': item.isParent}">
									<input type="checkbox" [checked]="item.checked" [disabled]="isItemDisabled(item) || isVehicleAssigned(item.id)" (click)="onCheckboxChange(item);" />
									<span [appDriverVehicleAssetIcon]="item" [entityType]="entityType"
										[ngStyle]="{ 'color': isItemDisabled(item) ? '#E6E6E6' : 'inherit', 'opacity': isItemDisabled(item) ? '0.4' : '1' }">
									</span>
									<span [ngStyle]="{ 'color': isItemDisabled(item) ? '#E6E6E6' : 'inherit' }">
										{{ item.name }}
									</span>
								</label>

								<label *ngIf="item.type === 'account' && !searchTerm">
									<span class="account-count">({{ getTotalEntities(item) | number }})</span>
									<span class="collapse-arrow" (click)="toggleCollapse(item); $event.stopPropagation()">
										<i [ngClass]="item.collapsed ? 'ph ph-caret-down' : 'ph ph-caret-up'"></i>
									</span>
								</label>

								<label *ngIf="item.type === 'driver' && shouldShowDocumentsWarning(item)">
									<svg [ngbTooltip]="'shared.assetAssignmentFilter.documentsWarning' | transloco"
											[animation]="true" class="driver-profile__notification_icon" width="16" height="16"
											viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												d="M8.26424 1.33301C4.60557 1.33301 1.62891 4.32367 1.62891 7.99967C1.62891 11.6757 4.61957 14.6663 8.29557 14.6663C11.9716 14.6663 14.9622 11.6757 14.9622 7.99967C14.9622 4.32367 11.9576 1.33301 8.26424 1.33301ZM8.96224 11.333H7.62891V9.99967H8.96224V11.333ZM8.96224 8.66634H7.62891V4.66634H8.96224V8.66634Z"
												fill="#FF7F00" />
										</svg>
								</label>

								<label class="asset-reg" *ngIf="item.type === 'asset'">
									<span class="plate-text">
										{{ item.assetLicensePlate ?? '-' }}
									</span>
									<span *ngIf="isSingleAssignment" class="assignment-icon"
										[ngClass]="{ invisible: !shouldShowAssignmentIcon(item) }">
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
											<path
												d="M12 2C6.579 2 2 6.579 2 12C2 17.421 6.579 22 12 22C17.421 22 22 17.421 22 12C22 6.579 17.421 2 12 2ZM12 7C13.727 7 15 8.272 15 10C15 11.728 13.727 13 12 13C10.274 13 9 11.728 9 10C9 8.272 10.274 7 12 7ZM6.894 16.772C7.791 15.452 9.287 14.572 11 14.572H13C14.714 14.572 16.209 15.452 17.106 16.772C15.828 18.14 14.015 19 12 19C9.985 19 8.172 18.14 6.894 16.772Z"
												fill="#9FA1A4"
											/>
										</svg>
									</span>
									<ng-container *ngIf="!isSingleAssignment">
										<span class="assignment-icon" #popover="ngbPopover"	placement="left"
											[ngbPopover]="popoverContent" [ngClass]="{ invisible: !shouldShowAssignmentIcon(item) }"
											(mouseenter)="openPopover(popover)"
											(mouseleave)="scheduleClosePopover(popover)">
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
												<path
													d="M12 2C6.579 2 2 6.579 2 12C2 17.421 6.579 22 12 22C17.421 22 22 17.421 22 12C22 6.579 17.421 2 12 2ZM12 7C13.727 7 15 8.272 15 10C15 11.728 13.727 13 12 13C10.274 13 9 11.728 9 10C9 8.272 10.274 7 12 7ZM6.894 16.772C7.791 15.452 9.287 14.572 11 14.572H13C14.714 14.572 16.209 15.452 17.106 16.772C15.828 18.14 14.015 19 12 19C9.985 19 8.172 18.14 6.894 16.772Z"
													fill="#9FA1A4"
												/>
											</svg>
										</span>
										<ng-template #popoverContent>
											<div class="tooltip-scrollable"	(mouseenter)="cancelClosePopover()" (mouseleave)="scheduleClosePopover(popover)">
												<div *ngFor="let name of getAssignedDriverNames(item.id)">
													{{ name }}
												</div>
											</div>
										</ng-template>
									</ng-container>
								</label>
							</div>
						</li>
					</cdk-virtual-scroll-viewport>
				</div>
			</ul>
		</span>
	</div>
</div>